import self from "../img/self.png"
import mock1 from "../img/mock1.png"
import mock2 from "../img/mock2.png"
import mock3 from "../img/mock3.png"
import mock4 from "../img/mock4.png"
import mock5 from "../img/mock5.png"
import mock6 from "../img/mock6.png"

export let colors = ["#1a3050", "#457b9d"];

export let singlePage = false;

export const info = {
    firstName: "Madhu",
    lastName: "Vanguri",
    initials: "MV",

    /* Array → typewriter cycles through each role */
    position: [
        "Mechanical Design Engineer",
        "SolidWorks · GD&T Specialist",
        "Medical Imaging Systems",
        "DFM / DFA · ANSYS FEA",
    ],

    selfPortrait: self,
    gradient: `linear-gradient(135deg, ${colors[0]}, ${colors[1]})`,
    baseColor: colors[0],

    miniBio: [
        {
            emoji: '⚙️',
            text: 'CAD · FEA · Medical Device Design'
        },
        {
            emoji: '📍',
            text: 'Hyderabad, Telangana, India'
        },
        {
            emoji: '🏭',
            text: 'RayMedis Medical Technologies'
        },
        {
            emoji: '✉️',
            text: 'vangurimadhu13@gmail.com'
        }
    ],

    socials: [
        {
            link: "https://www.linkedin.com/in/madhuvanguri",
            icon: "fa fa-linkedin",
            label: 'LinkedIn'
        },
        {
            link: "https://github.com/madhuvanguri",
            icon: "fa fa-github",
            label: 'GitHub'
        }
    ],

    bio: "Mechanical Design Engineer specialising in medical imaging systems, precision assemblies, and regulated product development. Proficient in SolidWorks, GD&T (ASME Y14.5), tolerance stack-up analysis, and DFM/DFA — delivering production-ready 3D models, detailed drawings, and BOM packages for X-ray equipment. Experienced in full product cycles from concept through design validation and manufacturing release, working cross-functionally with production, quality, and external vendors.",

    skills: {
        proficientWith: [
            'SolidWorks (Advanced)',
            'AutoCAD Mechanical',
            'CATIA V5',
            'ANSYS Workbench (FEA)',
            'GD&T (ASME Y14.5)',
            'Tolerance Stack-Up',
            'DFM / DFA',
            'Sheet Metal Design',
            'Welding & NDT',
            'BOM Management',
            'ECN / ECO',
        ],
        exposedTo: [
            'Python for Engineering',
            'MATLAB / Simulink',
            'Additive Manufacturing',
            'Project Management (Agile)',
            'CNC Machining',
        ]
    },

    hobbies: [
        { label: 'Rapid Prototyping', emoji: '🖨️' },
        { label: 'Automotive R&D',    emoji: '🏎️' },
        { label: 'Volleyball',        emoji: '🏐' },
        { label: 'Trekking',          emoji: '🥾' },
    ],

    portfolio: [
        {
            title: "X-Ray Chest Stand",
            live:   "/cad-work/project1/project1.html?model=Chest-Stand&title=Chest+Stand+Assembly",
            source: "/cad-work/four-views.html?image=/cad-work/project1/view1.png&title=Chest+Stand+Layout",
            image:  mock1
        },
        {
            title: "X-Ray Tube Shielding & Anode Heatsink",
            live:   "/cad-work/project2/project2.html?model=x-ray-tube&title=X-Ray+Tube+Assembly",
            source: "/cad-work/four-views.html?image=/cad-work/project2/view2.png&title=X-Ray+Layout",
            image:  mock2
        },
        {
            title: "X-Ray Monoblock Generator",
            live:   "/cad-work/project3/project3.html?model=MonoBlock&title=MonoBlock+Generator+Assembly",
            source: "/cad-work/four-views.html?image=/cad-work/project3/view3.png&title=MonoBlock+Layout",
            image:  mock3
        },
        {
            title: "IoT-Based Robotic Stretcher",
            live:   "/cad-work/robotic-stretcher-3d.html",
            source: "/cad-work/robotic-stretcher-drawing.pdf#toolbar=0&navpanes=0&scrollbar=0",
            image:  mock4
        },
        {
            title: "Lathe Machine",
            live:   "/cad-work/lathe-machine-3d.html",
            source: "/cad-work/lathe-machine-drawing.pdf#toolbar=0&navpanes=0&scrollbar=0",
            image:  mock5
        },
        {
            title: "Dynamic Serialization Generator",
            live:   "/cad-work/serialization-3d.html",
            source: "/cad-work/serialization-spec.pdf#toolbar=0&navpanes=0&scrollbar=0",
            image:  mock6
        }
    ]
};